import { useInstance } from '@meraki-internal/react-dependency-injection';
import { MiniWizardViewModelFactory } from './MiniWizardViewModel';
import { useSubscriptionV2 } from '../../../support/state/useSubscriptionV2';
import { CompositeWizardProvider } from './CompositeMiniWizardProvider';

export const useMiniWizard = (wizardKey: string, params: Map<string, string>) => {
    const wizardViewModelFactory = useInstance(MiniWizardViewModelFactory);
    const wizardQuestionsFactory = useInstance(CompositeWizardProvider);

    const viewModel = useSubscriptionV2(async () => {
        const questionnaire = wizardQuestionsFactory.create(wizardKey, params);
        return wizardViewModelFactory.create(questionnaire);
    }, wizardKey);

    return viewModel;
};
